
<div style="height: 100%;" class="d-flex flex-column position-relative">
  <div class="actionBar">
    <div class="flex-grow-1 h-100">
      <input class="search float-start" type="text" placeholder="Search" [formControl]="filterText" />
    </div>
    <button type="button" class="actionBtn" (click)="refresh()" placement="top auto" triggers="hover" ngbTooltip="Refresh Jobs">
      <span class="bi bi-arrow-clockwise"></span>
      <span class="button-animation">&nbsp;Refresh</span>
    </button>
  </div>
  <ng-container *ngIf="activeJobs.data?.length > 0; else nodata">
    <div class="overflow-x-auto w-100 flex-grow-1">
      <table mat-table [dataSource]="activeJobs" matSort class="details-table w-100">
        <ng-container *ngFor="let column of getColumns()" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.replace("Job", "") | camelCaseConvert}} </th>
          <td mat-cell *matCellDef="let element">
            @if(column == 'LastUpdateTime'){
              {{element[column] | date: 'medium'}} 
            } @else {
              @if(isCommaSeparated(element[column])) {
                <select class="form-select">
                  @for (node of element[column].split(","); track $index) {
                    <option>{{ node }}</option>
                  }
                </select>
              } @else {
                {{element[column] || "-"}} 
              }
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </ng-container>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="jobSummary"
    ></ngx-spinner
  >
</div>

<ng-template #nodata>
  <p class="mt-5 text-center">{{ noDataMsg }}</p>
</ng-template>


